/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_Required_SubmittedInputs */



/**
* | output |
* | --- |
* | "Decklist submitted. You can replace it until the tournament starts." |
*
* @param {Decks_Required_SubmittedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_required_submitted = /** @type {((inputs?: Decks_Required_SubmittedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Required_SubmittedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decklist soumise. Vous pouvez la remplacer jusqu'au début du tournoi.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Decklist enviada. Puede reemplazarla hasta que comience el torneo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Decklist enviada. Você pode substituí-la até o início do torneio.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Decklist inviata. Può sostituirla fino all'inizio del torneo.")
	return /** @type {LocalizedString} */ ("Decklist submitted. You can replace it until the tournament starts.")
});